module.exports = __webpack_public_path__ + "img/icon-previous.db531875.svg";